<template>
  <div class="privacy-policy py-4">
    <p class="pp-brand-name">MY LIFE CLICK</p>
    <p class="pp-brand-sub"><em>una solución de SIGABRAD</em></p>
    <p class="pp-brand-doc"><em>CNPJ: 44.360.218/0001-22</em></p>

    <h1 class="pp-title">
      Política de Privacidad, Protección de Datos y Términos de Uso
    </h1>
    <p class="pp-legal-basis">
      <em
        >De conformidad con la Ley n.º 13.709/2018 (Ley General de Protección de
        Datos Personales de Brasil – LGPD), el Marco Civil de Internet (Ley n.º
        12.965/2014), el Código de Defensa del Consumidor (Ley n.º 8.078/1990) y
        las directrices vigentes de la Autoridad Nacional de Protección de Datos
        de Brasil (ANPD)</em
      >
    </p>
    <p class="pp-meta">
      Versión actualizada — 25 de agosto de 2026 · Sustituye íntegramente la
      versión de agosto de 2021
    </p>

    <h2 class="pp-section">
      1. Naturaleza de este Documento y Responsabilidad por su Cumplimentación
    </h2>
    <p>
      Este es un documento modelo (template), estructurado por My Life Click /
      SIGABRAD para uso de sus clientes adquirentes — hospitales, clínicas,
      instituciones educativas, organizadores de eventos, empresas y demás
      personas jurídicas que licencian la plataforma para la identificación de
      sus propios titulares (pacientes, alumnos, colaboradores, participantes,
      etc.).
    </p>
    <p>
      Todos los campos indicados como "[a completar por el Adquirente]" a lo
      largo de este documento son de responsabilidad exclusiva del Adquirente de
      los productos My Life Click, quien deberá completarlos, validarlos con su
      propia asesoría jurídica y publicarlos antes de poner el servicio a
      disposición de sus titulares finales. My Life Click no completa, no valida
      ni asume responsabilidad por el contenido de esos campos.
    </p>

    <h2 class="pp-section">
      2. Identificación de las Partes y Roles (Controlador x Operador)
    </h2>
    <p>
      En los términos del Art. 5.º, incisos VI y VII, de la LGPD, se distinguen
      dos roles en esta relación:
    </p>
    <ul class="pp-list">
      <li>
        My Life Click / SIGABRAD actúa, por regla general, como Operador —
        provee la tecnología de identificación digital (Código QR, NFC y RFID),
        la infraestructura de la plataforma y, cuando sea contratado para ello,
        el soporte al tratamiento de datos por cuenta y orden del Adquirente.
      </li>
      <li>
        Adquirente de los productos My Life Click: persona jurídica que contrata
        la plataforma y la pone a disposición de sus propios titulares. Por
        regla general, es el Adquirente quien figura como Controlador frente a
        esos titulares finales, correspondiéndole a él las decisiones sobre la
        finalidad y la forma del tratamiento de los datos recolectados por medio
        de los brazaletes, tarjetas y demás dispositivos entregados a sus
        usuarios.
      </li>
      <li>
        En caso de duda, comuníquese por correo electrónico a
        <a href="mailto:yusefwehbe@gmail.com">yusefwehbe@gmail.com</a>
      </li>
      <li>
        <strong>Identificación del Adquirente/Controlador: </strong>
        <em class="pp-placeholder"
          >[a completar por el Adquirente — razón social, CNPJ/identificación
          fiscal, domicilio y datos de contacto]</em
        >
      </li>
    </ul>
    <p class="pp-note">
      <em
        >Nota: en implementaciones específicas en las que My Life Click opere
        directamente en modalidad B2C (relación directa con el consumidor final,
        sin un Adquirente institucional intermediario), My Life Click asume el
        rol de Controlador y debe completar estos mismos campos con sus propios
        datos.</em
      >
    </p>
    <p>
      El Controlador identificado anteriormente es responsable de las decisiones
      relativas al tratamiento de los datos personales recolectados por medio
      del sitio web, de los brazaletes, tarjetas y demás dispositivos de
      identificación con tecnología Código QR, NFC y RFID, aplicaciones y
      canales de atención asociados a su implementación de la plataforma.
    </p>

    <h2 class="pp-section">3. Definiciones</h2>
    <ul class="pp-list">
      <li>
        <strong>Dato personal:</strong> información relacionada con una persona
        natural identificada o identificable.
      </li>
      <li>
        <strong>Dato personal sensible:</strong> dato referente a la salud,
        origen étnico, convicción religiosa, opinión política, dato genético o
        biométrico, cuando esté vinculado a una persona natural.
      </li>
      <li>
        <strong>Titular:</strong> persona natural a quien se refieren los datos
        personales objeto de tratamiento.
      </li>
      <li>
        <strong>Tratamiento:</strong> toda operación realizada con datos
        personales, como recolección, uso, acceso, almacenamiento, eliminación y
        compartición.
      </li>
      <li>
        <strong>Controlador:</strong> persona jurídica a quien competen las
        decisiones referentes al tratamiento de datos personales.
      </li>
      <li>
        <strong>Operador:</strong> persona jurídica que realiza el tratamiento
        de datos personales en nombre del Controlador.
      </li>
      <li>
        <strong>Encargado (DPO):</strong> persona designada para actuar como
        canal de comunicación entre el Controlador, los titulares y la ANPD.
      </li>
      <li>
        <strong>ANPD:</strong> Autoridad Nacional de Protección de Datos de
        Brasil.
      </li>
    </ul>

    <h2 class="pp-section">4. Datos Personales Recopilados</h2>
    <p>
      Debido a la naturaleza multivertical de la plataforma — identificación de
      titulares con enfermedades crónicas, Trastorno del Espectro Autista y TDAH
      (en el marco del programa PIPTEA, conforme a la Ley Federal n.º
      13.977/2020), enfermedades raras, identificación de mascotas, seguridad
      corporativa y grandes eventos —, My Life Click podrá tratar las siguientes
      categorías de datos, siempre limitadas al mínimo necesario para cada
      finalidad (principio de necesidad, Art. 6.º, III):
    </p>
    <h3 class="pp-subsection">4.1. Datos registrales</h3>
    <ul class="pp-list">
      <li>
        Nombre completo, correo electrónico, celular, contraseña de acceso e
        idioma preferido.
      </li>
      <li>
        Datos del responsable legal, cuando el titular sea niño, adolescente o
        persona con discapacidad bajo curatela o representación.
      </li>
    </ul>
    <h3 class="pp-subsection">
      4.2. Datos sensibles de salud (cuando se proporcionan voluntariamente por
      el titular o su responsable)
    </h3>
    <ul class="pp-list">
      <li>
        Condiciones médicas, diagnósticos, alergias, medicamentos en uso y
        contactos de emergencia, vinculados al brazalete o tarjeta de
        identificación.
      </li>
      <li>
        Información relativa al diagnóstico de TEA/TDAH, exclusivamente para
        fines de identificación y protección del titular, en los términos de la
        Ley n.º 13.977/2020 (Ley Romeo Mion / PIPTEA).
      </li>
    </ul>
    <h3 class="pp-subsection">4.3. Datos de navegación</h3>
    <ul class="pp-list">
      <li>
        Dirección IP, tipo de dispositivo, cookies e identificadores de sesión,
        recolectados conforme a la Política de Cookies (Sección 13).
      </li>
    </ul>
    <h3 class="pp-subsection">4.4. Datos de terceros vinculados</h3>
    <ul class="pp-list">
      <li>
        Cuando el titular registra datos de dependientes, mascotas o personas
        bajo su responsabilidad, el propio titular es responsable de obtener el
        consentimiento o de contar con la base legal aplicable para el registro
        de dichos datos.
      </li>
    </ul>

    <h2 class="pp-section">5. Finalidad y Base Legal del Tratamiento</h2>
    <p>
      Cada finalidad de tratamiento está asociada a una base legal específica
      prevista en los Arts. 7.º y 11 de la LGPD, según se detalla a
      continuación. El tratamiento de datos sensibles de salud observa un rigor
      adicional, realizándose solo con consentimiento específico, destacado e
      informado del titular o de su responsable legal.
    </p>
    <div class="pp-table-wrap">
      <table class="pp-table">
        <thead>
          <tr>
            <th>Finalidad del tratamiento</th>
            <th>Base legal (LGPD)</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Registro y creación de cuenta</td>
            <td>
              Ejecución de contrato / procedimientos preliminares (Art. 7.º, V)
            </td>
          </tr>
          <tr>
            <td>
              Emisión y vinculación del brazalete/tarjeta de identificación
              (Código QR, NFC, RFID)
            </td>
            <td>
              Ejecución de contrato y, cuando corresponda, protección de la vida
              o integridad física del titular (Art. 7.º, VII)
            </td>
          </tr>
          <tr>
            <td>
              Datos de salud vinculados a enfermedades crónicas, TEA/TDAH
              (PIPTEA) y enfermedades raras
            </td>
            <td>
              Consentimiento específico y destacado del titular o de su
              responsable legal, para la tutela de la salud, en un procedimiento
              realizado exclusivamente por profesionales de la salud o entidades
              sanitarias (Art. 11, II, "f")
            </td>
          </tr>
          <tr>
            <td>
              Comunicaciones, ofertas y promociones por correo electrónico
            </td>
            <td>Consentimiento (opt-in), revocable en cualquier momento</td>
          </tr>
          <tr>
            <td>Métricas de uso, analítica y cookies no esenciales</td>
            <td>
              Consentimiento, conforme a las preferencias configuradas por el
              titular
            </td>
          </tr>
          <tr>
            <td>Cumplimiento de obligación legal o regulatoria</td>
            <td>
              Obligación legal o regulatoria del Controlador (Art. 7.º, II)
            </td>
          </tr>
          <tr>
            <td>Prevención de fraudes y seguridad del titular</td>
            <td>
              Interés legítimo del Controlador, con evaluación de impacto (Art.
              7.º, IX)
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <p class="pp-note">
      <em
        >Nota: el consentimiento para datos sensibles siempre se solicita de
        forma destacada, separada de los demás términos de uso, con finalidad
        específica y determinada, conforme al Art. 11, I, de la LGPD.</em
      >
    </p>

    <h2 class="pp-section">6. Consentimiento</h2>
    <p>
      El consentimiento es libre, informado e inequívoco, recolectado mediante
      un mecanismo de aceptación activa (no premarcada), en el momento del
      registro. El titular puede revocar el consentimiento en cualquier momento,
      mediante solicitud al Encargado, sin perjuicio de la licitud del
      tratamiento realizado antes de la revocación.
    </p>
    <p>
      Para los datos de niños y adolescentes, el consentimiento se obtiene
      específicamente del responsable legal, observando el interés superior del
      niño, conforme al Art. 14 de la LGPD y al Estatuto del Niño y del
      Adolescente.
    </p>

    <h2 class="pp-section">7. Compartición de Datos</h2>
    <p>
      My Life Click no comparte datos personales con terceros para fines
      comerciales ajenos a la prestación del servicio. La compartición ocurre,
      exclusivamente, en los siguientes supuestos:
    </p>
    <ul class="pp-list">
      <li>
        Con operadores contratados para hospedaje, procesamiento de pagos y
        soporte técnico, mediante contrato que garantice un estándar de
        protección equivalente.
      </li>
      <li>
        Con profesionales de la salud, equipos de emergencia o entidades
        públicas, en el momento de la lectura del Código QR/NFC, con fines de
        protección de la vida y la integridad física del titular.
      </li>
      <li>
        Con socios institucionales (hospitales, clínicas, entidades de apoyo a
        enfermedades raras, instituciones educativas), exclusivamente mediante
        base legal y/o consentimiento específico del titular.
      </li>
      <li>
        Por determinación legal, orden judicial o requerimiento de autoridad
        competente.
      </li>
    </ul>
    <p>
      El Controlador exige a todos los operadores y socios el cumplimiento de
      obligaciones equivalentes a las previstas en la LGPD, formalizadas
      mediante contrato o acuerdo de tratamiento de datos (DPA).
    </p>

    <h2 class="pp-section">8. Transferencia Internacional de Datos</h2>
    <p>
      En caso de que los datos personales sean transferidos a servidores o
      proveedores de servicios ubicados fuera del territorio nacional, dicha
      transferencia observará una de las hipótesis del Art. 33 de la LGPD,
      incluyendo la existencia de una decisión de adecuación de la ANPD,
      cláusulas contractuales estándar, normas corporativas globales o sellos y
      certificaciones reconocidos, garantizando un nivel de protección adecuado
      a los datos transferidos.
    </p>

    <h2 class="pp-section">9. Retención y Eliminación de Datos</h2>
    <p>
      Los datos personales se conservan solo durante el período necesario para
      el cumplimiento de las finalidades para las que fueron recolectados,
      observando los plazos de conservación obligatoria previstos por ley
      (fiscal, civil y regulatoria). Finalizada la finalidad, los datos se
      eliminan o anonimizan, salvo en los supuestos del Art. 16 de la LGPD
      (cumplimiento de obligación legal, estudio por organismo de investigación,
      transferencia a terceros respetando los requisitos de tratamiento, o uso
      exclusivo del Controlador, vedado el acceso a terceros, y siempre que los
      datos estén anonimizados).
    </p>

    <h2 class="pp-section">10. Seguridad de la Información</h2>
    <p>
      El Controlador adopta medidas técnicas y administrativas aptas para
      proteger los datos personales frente a accesos no autorizados y
      situaciones accidentales o ilícitas de destrucción, pérdida, alteración,
      comunicación o difusión, incluyendo: cifrado de datos sensibles en
      tránsito y en reposo, control de acceso por perfil (mínimo privilegio),
      autenticación multifactor para el acceso administrativo, registro (log) de
      accesos y pista de auditoría, y pruebas periódicas de seguridad.
    </p>
    <p>
      En caso de incidente de seguridad que pueda ocasionar riesgo o daño
      relevante a los titulares, el Controlador comunicará a la ANPD y a los
      titulares afectados en un plazo razonable, conforme al Art. 48 de la LGPD,
      informando la naturaleza de los datos afectados, las medidas técnicas
      adoptadas y los riesgos relacionados con el incidente.
    </p>

    <h2 class="pp-section">11. Derechos del Titular de los Datos</h2>
    <p>
      En los términos del Art. 18 de la LGPD, el titular tiene derecho a obtener
      del Controlador, en cualquier momento y mediante solicitud:
    </p>
    <div class="pp-table-wrap">
      <table class="pp-table pp-table--rights">
        <tbody>
          <tr>
            <th>Confirmación y acceso</th>
            <td>
              Saber si sus datos son tratados y acceder al contenido tratado.
            </td>
          </tr>
          <tr>
            <th>Corrección</th>
            <td>Corregir datos incompletos, inexactos o desactualizados.</td>
          </tr>
          <tr>
            <th>Anonimización, bloqueo o eliminación</th>
            <td>
              De datos innecesarios, excesivos o tratados en desconformidad con
              la LGPD.
            </td>
          </tr>
          <tr>
            <th>Portabilidad</th>
            <td>
              Solicitar la transferencia de los datos a otro proveedor de
              servicio, mediante solicitud expresa.
            </td>
          </tr>
          <tr>
            <th>Eliminación</th>
            <td>
              Eliminación de los datos personales tratados con consentimiento,
              salvo los supuestos de conservación obligatoria.
            </td>
          </tr>
          <tr>
            <th>Información sobre la compartición</th>
            <td>
              Saber con qué entidades públicas y privadas el Controlador
              compartió los datos.
            </td>
          </tr>
          <tr>
            <th>Información sobre la posibilidad de no consentir</th>
            <td>Y las consecuencias de la negativa.</td>
          </tr>
          <tr>
            <th>Revocación del consentimiento</th>
            <td>
              En cualquier momento, mediante manifestación expresa, sin afectar
              la licitud del tratamiento anterior.
            </td>
          </tr>
          <tr>
            <th>Revisión de decisiones automatizadas</th>
            <td>
              Solicitar revisión humana de decisiones tomadas únicamente con
              base en tratamiento automatizado.
            </td>
          </tr>
          <tr>
            <th>Oposición</th>
            <td>
              Oponerse al tratamiento realizado con base en una hipótesis legal
              distinta del consentimiento, en caso de incumplimiento de la LGPD.
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <p>
      Las solicitudes pueden realizarse por medio del canal indicado en la
      Sección 12 y serán respondidas en un plazo razonable, observando los
      plazos reglamentarios de la ANPD.
    </p>

    <h2 class="pp-section">12. Encargado de Protección de Datos (DPO)</h2>
    <p>
      El Controlador (Adquirente, conforme a la Sección 2) designa un Encargado
      de Protección de Datos (Data Protection Officer), responsable de atender
      las solicitudes de los titulares, comunicarse con la ANPD y orientar a los
      colaboradores sobre las prácticas de protección de datos.
    </p>
    <p>
      <strong>Canal de atención al titular / Encargado: </strong>
      <em class="pp-placeholder"
        >[a completar por el Adquirente — nombre del Encargado, correo
        electrónico dedicado de privacidad y canal de contacto oficial]</em
      >
    </p>
    <p class="pp-note">
      <em
        >Campo de responsabilidad exclusiva del Adquirente, que deberá
        completarse antes de la publicación de este documento a sus titulares —
        se recomienda un correo electrónico dedicado de privacidad, distinto del
        correo comercial, para la trazabilidad de las solicitudes recibidas.</em
      >
    </p>

    <h2 class="pp-section">13. Cookies</h2>
    <p>
      El sitio web y la plataforma My Life Click utilizan cookies para habilitar
      funcionalidades esenciales (cuenta, inicio de sesión, procesamiento de
      pedidos), mejorar la experiencia del usuario y realizar análisis de uso,
      incluso mediante herramientas de terceros como Google Analytics.
    </p>
    <h3 class="pp-subsection">13.1. Categorías de cookies</h3>
    <ul class="pp-list">
      <li>
        Estrictamente necesarias: esenciales para el funcionamiento del sitio y
        la seguridad de la cuenta; no requieren consentimiento previo.
      </li>
      <li>
        De rendimiento y analítica: recopilan datos agregados sobre el uso del
        sitio; requieren el consentimiento del titular.
      </li>
      <li>
        De funcionalidad: memorizan las preferencias del usuario (idioma,
        configuraciones).
      </li>
      <li>
        De terceros: cookies definidas por socios de análisis, sujetas a sus
        respectivas políticas de privacidad.
      </li>
    </ul>
    <p>
      El titular puede gestionar sus preferencias de cookies en cualquier
      momento mediante el banner de consentimiento o la configuración del
      navegador. La desactivación de cookies no esenciales no afecta el
      funcionamiento básico del sitio; la desactivación de cookies esenciales
      puede comprometer funcionalidades como el inicio de sesión y el
      procesamiento de pedidos.
    </p>

    <h2 class="pp-section">
      14. Datos de Niños, Adolescentes y Personas con Discapacidad
    </h2>
    <p>
      Considerando que parte de las verticales de My Life Click está destinada a
      la identificación de niños y personas con Trastorno del Espectro Autista
      (programa PIPTEA), el tratamiento de los datos de estos titulares observa
      una protección reforzada: recolección limitada a lo estrictamente
      necesario para la finalidad de identificación y protección, consentimiento
      específico del responsable legal, prohibición de uso de los datos con
      fines publicitarios dirigidos a estas categorías de titulares, y
      posibilidad de eliminación de los datos en cualquier momento mediante
      solicitud del responsable legal.
    </p>

    <h2 class="pp-section">15. Compromiso del Usuario</h2>
    <p>Al utilizar la plataforma My Life Click, el usuario se compromete a:</p>
    <ul class="pp-list">
      <li>
        No utilizar los servicios para fines ilícitos o contrarios al orden
        público.
      </li>
      <li>
        No difundir contenido discriminatorio, racista, xenófobo, de apología a
        la violencia o a actividades ilegales.
      </li>
      <li>
        No intentar comprometer la seguridad de los sistemas del Controlador, de
        proveedores o de terceros, incluyendo intentos de introducción de virus,
        malware o ingeniería inversa no autorizada.
      </li>
      <li>
        Proporcionar información verdadera, precisa y actualizada al momento del
        registro.
      </li>
    </ul>

    <h2 class="pp-section">16. Propiedad Intelectual y Licencia de Uso</h2>
    <p>
      Los materiales disponibles en el sitio web y en la plataforma My Life
      Click (textos, marca, diseño, software y tecnología de identificación
      Código QR/NFC/RFID) están protegidos por derechos de autor y de propiedad
      industrial. Se concede al usuario una licencia limitada, personal, no
      exclusiva e intransferible para el uso de los servicios conforme a su
      finalidad, quedando prohibidas la copia, modificación, ingeniería inversa,
      distribución o explotación comercial no autorizada de los materiales.
    </p>

    <h2 class="pp-section">17. Exención y Limitación de Responsabilidad</h2>
    <p>
      Los materiales y servicios se proporcionan "tal cual". My Life Click no
      ofrece garantías, expresas o implícitas, y por medio del presente exime y
      niega todas las demás garantías, y no se responsabiliza por daños
      indirectos derivados del uso o de la imposibilidad de uso de los
      servicios, salvo en los supuestos de dolo, culpa grave o infracción de una
      norma de protección de datos imputable al Controlador, en los términos del
      Código de Defensa del Consumidor y de la LGPD.
    </p>
    <p class="pp-note">
      <em
        >Nota: las cláusulas de limitación de responsabilidad frente a los
        consumidores están sujetas a las normas de orden público del CDC, que
        prohíben la exoneración de responsabilidad en supuestos de vicio o
        defecto del servicio; se recomienda la validación jurídica de esta
        sección conforme al público objetivo (B2C, B2B o sector público).</em
      >
    </p>

    <h2 class="pp-section">18. Enlaces a Sitios Externos</h2>
    <p>
      La plataforma puede contener enlaces a sitios de terceros. My Life Click
      no analiza ni se responsabiliza por el contenido, las prácticas de
      privacidad o la seguridad de sitios externos, siendo el acceso a dichos
      sitios de responsabilidad exclusiva del usuario.
    </p>

    <h2 class="pp-section">19. Modificaciones de esta Política</h2>
    <p>
      Esta Política podrá actualizarse en cualquier momento, para reflejar
      cambios legislativos, regulatorios u operativos. Los cambios relevantes se
      comunicarán a los titulares por correo electrónico o mediante aviso
      destacado en la plataforma, indicando la nueva fecha de vigencia. El uso
      continuado de los servicios tras la comunicación del cambio implica el
      conocimiento de los nuevos términos.
    </p>

    <h2 class="pp-section">20. Legislación Aplicable y Fuero</h2>
    <p>
      Esta Política se rige por las leyes de la República Federativa de Brasil,
      en especial por la Ley n.º 13.709/2018 (LGPD), la Ley n.º 12.965/2014
      (Marco Civil de Internet) y el Código de Defensa del Consumidor. Se elige
      el fuero del domicilio del titular/consumidor para dirimir controversias
      derivadas de esta Política, salvo competencia diversa prevista por ley,
      quedando prohibida la elección de un fuero que dificulte el acceso del
      titular a la justicia.
    </p>

    <h2 class="pp-section">21. Vigencia</h2>
    <p>
      Esta Política entra en vigor a partir del 25 de agosto de 2026 y sustituye
      íntegramente cualquier versión anterior publicada por el Adquirente.
    </p>

    <hr class="pp-divider" />
    <p class="pp-footnote">
      <em
        >Este documento fue elaborado por My Life Click con fines de
        organización y actualización de contenido, con base en la legislación
        brasileña de protección de datos (LGPD) y en las mejores prácticas de
        mercado, en calidad de modelo (template) a ser adaptado por cada
        Adquirente. La cumplimentación, validación y publicación de los campos
        indicados como "[a completar por el Adquirente]" son de responsabilidad
        exclusiva del Adquirente de los productos My Life Click, quien también
        deberá contar con el análisis de un abogado o despacho especializado en
        protección de datos y derecho digital habilitado en su jurisdicción,
        adecuar el documento a su tamaño y sector de actuación (desde organismos
        públicos hasta multinacionales) y elaborar un Informe de Impacto en la
        Protección de Datos (RIPD), recomendado dado el tratamiento de datos
        sensibles de salud. My Life Click no se responsabiliza por el contenido
        incorporado por el Adquirente en dichos campos.</em
      >
    </p>
  </div>
</template>

<script>
export default {
  name: "privacy-policy-es",
};
</script>
